import {CommonModule} from '@angular/common';
import {NgModule, ModuleWithProviders} from '@angular/core';
import {LaTextComponent} from './la-text.component';
import {LaColorService} from '../colors/la-color.service';

export {LaTextComponent} from './la-text.component';
export {LaColorService} from '../colors/la-color.service';

// Export module's public API

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [LaTextComponent],
  declarations: [LaTextComponent],
  providers: [LaColorService]
})
export class LaTextModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaTextModule,
      providers: [LaColorService]
    };
  }
}
